<template>
  <MasterDetail
    ref="masterDetail"
    :canDelete="false"
    :cols="cols"
    formTitle="Nível hierarquico"
    :hasExportCSV="false"
    :hasExportXLSX="false"
    :opts="opts"
    :customResource="customResource"
    serverPagination
  ></MasterDetail>
</template>

<script>
import MasterDetail from "@/components/master-detail.vue";
import { mapGetters } from "vuex";
import niveisHierarquicosService from "@/api/ativacaoped/niveis-hierarquicos.service";
import { createServiceResource } from "@/api/ativacaoped/resource-adapter";

export default {
  components: {
    MasterDetail
  },
  data() {
    return {
      opts: {
        tipos: []
      }
    };
  },
  computed: {
    ...mapGetters(["clientId"]),
    cols() {
      const selectedItem = this.$refs.masterDetail?.selectedItem || {};
      const { descricao } = this.opts.tipos.find(({ id }) => selectedItem.tipo_id === id) || {};

      return [
        {
          key: "nome",
          name: "Nome",
          type: this.$fieldTypes.TEXT,
          rules: [{ rule: "required" }, { rule: "max", params: { size: 255 } }]
        },
        {
          key: "tipo_id",
          name: "Tipo",
          type: this.$fieldTypes.AUTOCOMPLETE,
          rel: { to: "tipos", key: "id", name: "nome" },
          rules: [{ rule: "required" }]
        },
        {
          key: "subtitle",
          name: descricao,
          type: this.$fieldTypes.SUBTITLE,
          hideInTable: true,
          hideInform: !descricao
        }
      ];
    },
    /**
     * Resource service-backed consumido pelo `MasterDetail` (`get` na grid e
     * `save` no formulário). `delete` está desabilitado na tela
     * (`:canDelete="false"`), então não é exposto aqui.
     * Substitui o `:resourceUrl`, que usava o `apiResource` inline do mixin.
     *
     * @returns {Object} Resource no contrato do `apiResource`
     */
    customResource() {
      // Ver nota em `divisoes.vue`: ler `clientId` aqui mantém o reload da grid
      // pelo watcher de `customResource` do `MasterDetail`.
      const clientId = this.clientId;

      return createServiceResource({
        notify: this.notify,
        get: ({ query }) =>
          niveisHierarquicosService.getNiveisHierarquicos(clientId, query),
        save: (data, id) =>
          id
            ? niveisHierarquicosService.putNivelHierarquico(clientId, id, data)
            : niveisHierarquicosService.postNivelHierarquico(clientId, data)
      });
    }
  },
  created() {
    if (this.clientId === 0) {
      this.goToHome();
    } else {
      this.getTypes();
    }
  },
  watch: {
    clientId(value) {
      if (value === 0) {
        this.goToHome();
      }
    }
  },
  methods: {
    async getTypes() {
      try {
        const response = await niveisHierarquicosService.getTiposNivelHierarquico(
          this.clientId
        );
        this.opts.tipos = response;
      } catch (error) {
        this.opts.tipos = [];
        this.notify(error);
      }
    },
    goToHome() {
      this.notify({
        error:
          "Não é possível acessar o módulo de Ativação P&D sem uma empresa selecionada."
      });
      this.$router.push({ name: "homepage" });
    }
  }
};
</script>
